import { render, staticRenderFns } from "./PDFChatBtm.vue?vue&type=template&id=41402429&scoped=true&"
import script from "./PDFChatBtm.vue?vue&type=script&lang=js&"
export * from "./PDFChatBtm.vue?vue&type=script&lang=js&"
import style0 from "./PDFChatBtm.vue?vue&type=style&index=0&id=41402429&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41402429",
  null
  
)

export default component.exports